import { render, staticRenderFns } from "./IVRMenuRingGroupSetting.vue?vue&type=template&id=e5c1ffb0&"
import script from "./IVRMenuRingGroupSetting.vue?vue&type=script&lang=js&"
export * from "./IVRMenuRingGroupSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports